import { Component, OnDestroy, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { IMetaData, TrendencySeoService } from '@trendency/utils';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { BaseService } from '../../core/components/base/base.service';
import { ComponentMapService } from '../../shared/services/component-map.service';

@Component({
  selector: 'app-form-elements',
  templateUrl: './form-elements.component.html',
  styleUrls: ['./form-elements.component.scss'],
})
export class FormElementsComponent implements OnInit, OnDestroy {
  @ViewChild('bodyAnchor', { read: ViewContainerRef, static: true }) private readonly bodyAnchor: ViewContainerRef;
  title: string;
  data: any;
  private readonly destroy$ = new Subject();

  constructor(
    private readonly activatedRoute: ActivatedRoute,
    private readonly componentMapService: ComponentMapService,
    private readonly seo: TrendencySeoService,
    private readonly baseService: BaseService
  ) {}

  ngOnInit(): void {
    this.baseService.setFormElementsVisibility(true);
    this.activatedRoute.data.pipe(takeUntil(this.destroy$)).subscribe((res) => {
      this.data = res['data'];
      this.bodyAnchor.clear();
      const bodyComponents = JSON.parse(JSON.stringify(this.data.data.body));

      if (bodyComponents.length && (bodyComponents[0].type === 'Body.ContentHero' || bodyComponents[0].type === 'Body.HungaryForHero')) {
        this.title = '';
      } else {
        const metaTitle = this.componentMapService.getComponentAsObjectByType(this.data.data.meta, 'Meta.Title');
        this.title = metaTitle.text;
      }

      this.componentMapService.generateComponents(bodyComponents, this.bodyAnchor);
      this.setMetaData();

      this.baseService.setSz2020Logo(
        this.componentMapService.getComponentAsObjectByType(this.data?.data?.meta, 'Meta.GinopLogoStatus')?.ginopLogoStatus
      );
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.complete();
  }

  setMetaData(): void {
    const metaTitle = this.componentMapService.getComponentAsObjectByType(this.data.data.meta, 'Meta.Title');
    const metaLead = this.componentMapService.getComponentAsObjectByType(this.data.data.meta, 'Meta.Lead');
    const metaThumbnail = this.componentMapService.getComponentAsObjectByType(this.data.data.meta, 'Meta.Thumbnail');
    const metaData: IMetaData = {
      title: metaTitle.text,
      description: metaLead.text,
      ogTitle: metaTitle.text,
      ogImage: metaThumbnail?.image?.url,
      ogImageAlt: metaThumbnail?.image?.image?.title,
      ogType: 'article',
    };
    this.seo.setMetaData(metaData);
  }
}
